import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'
import { compose } from 'redux'

import { PassengerBookings as View } from './PassengerBookings'

import { passengerActions } from 'reduxModules/actions/PassengerActions'
import { bookingsSelector, isLoadingSelector } from 'reduxModules/selectors/PassengerSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  bookings: bookingsSelector,
  isLoading: isLoadingSelector,
})

const mapDispatchToProps = {
  getPassengerBookings: passengerActions.getPassengerBookings
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const PassengerBookings = enhance(View)


// WEBPACK FOOTER //
// ./src/components/PassengerBookings/index.js